export const MINIMUM_VELOCITY_METERS_PER_MILLISECONDS = 0.0134112
export const MAXIMUM_VELOCITY_METERS_PER_MILLISECONDS = 0.0268224
